module.exports = __webpack_public_path__ + "img/logo-space-fitters.fc818277.svg";